import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Organization } from "../../../core/models/entities/Organization";
import { CLARITY_MASK, CLARITY_MASK_TOOLTIP } from "../../../utils/analytics/clarityAttrs";

interface CustomerTooltipProps {
  customer?: Organization | null;
}

export default function CustomerTooltip({ customer }: CustomerTooltipProps) {
  const { t } = useTranslation();
  const name = customer?.name ?? "";
  const navNumber = customer?.navNumber ?? "";
  const tooltipTitle = customer
    ? customer.isVendor
      ? `${name} (${navNumber})`
      : name
    : t("compMisc.customerInfoUnavailable");

  // Clarity masking (design 5.2): customer name in every list row that uses
  // this - the span and the tooltip bubble (portal).
  return (
    <Tooltip
      title={tooltipTitle}
      placement={"top-start"}
      componentsProps={CLARITY_MASK_TOOLTIP}
    >
      <span
        className={"whitespace-nowrap overflow-x-hidden overflow-ellipsis"}
        {...CLARITY_MASK}
      >
        {name}
      </span>
    </Tooltip>
  );
}
